import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TwoFactorService} from '../../services/two-factor.service';
import {CodaltComponent} from '../../codalt.component';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {LocalStorage} from '../../storage.class';
import {Utils} from '../../utils.class';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {QRCodeComponent} from "angularx-qrcode";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-two-factor-setup',
    templateUrl: './two-factor-setup.component.html',
    styleUrls: ['./two-factor-setup.component.scss'],
    imports: [
        VvrIconComponent,
        QRCodeComponent,
        MatFormField,
        MatLabel,
        MatError,
        MatInput,
        FormsModule,
        RouterLink,
        MatButton
    ]
})
export class TwoFactorSetupComponent extends CodaltComponent implements OnInit {

    readonly twoFactor = signal<{ qr: null, secret: null }>(null);
    private readonly _twoFactorCode = signal('');

    constructor(
        private TwoFa: TwoFactorService,
        private authService: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
    }

    // Getter and setter for ngModel two-way binding
    get twoFactorCode(): string {
        return this._twoFactorCode();
    }

    set twoFactorCode(value: string) {
        this._twoFactorCode.set(value);
    }

    ngOnInit(): void {
        this.subscriptions.add(this.route.params.subscribe(params => {
            if (params['token']) {
                LocalStorage.setUserToken(params['token']);
            }
            const tokenData = Utils.getJwtData(LocalStorage.getUserToken());
            if (tokenData.setupOtp) {
                this.TwoFa.get2FaQr().subscribe(qr => this.twoFactor.set(qr.data));
            }
        }));
    }

    setup() {
        this.TwoFa.save2Fa(this._twoFactorCode(), this.twoFactor().secret).subscribe(hash => {
            this.authService.refresh().subscribe(() => {
                this.router.navigate(['/']);
            });
        });
    }

}
